import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MobileNav from '../global/Mobile/MobileNav';

import GalleryCarousel from './GalleryCarousel';
import GalleryVideos from './GalleryVideos';


import * as Header from '../../assets/img/headers/pretty-social.png';


var HeaderStyle = {
  backgroundImage: `url(${Header})`,
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'scroll',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundOrigin: 'border-box'
};

class Gallery extends Component {
  render() {
        return (
          <div>


<div  className="nav-container">


<nav className="primary-nav light">
      <Link to="/products">Products</Link>
      <Link to="/styles">Styles</Link>
      <Link to="/gallery">Gallery</Link>
      <Link to="/about">About</Link>
    </nav>

</div>

            <MobileNav />
            <header className="large-header light push" style={HeaderStyle}>
    <div className="header-container">
      <div className="content">
        <Link to="/products" className="btn">
         <strong> Pretty & Lashed</strong> <br/> by Shanise
        </Link>
      </div>
    </div>

     <div className="down-arrow" aria-hidden="true">
       <span className="arrow"> &#10095; </span>
       </div>
       </header>
         <GalleryVideos/>
            <GalleryCarousel/>
          </div> 
        )
    }
}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.js